import React from "react";
import { NavLink } from "react-router-dom"; // Import NavLink
import './Footer.css';
import footer_logo from '../Assets/splogo.png';

const Footer = () => {
  return (
    // Changed to a <footer> tag
    <footer className="footer">
      <div className="footer__main-content container">
        {/* The duplicate Limebar has been REMOVED */}

        <div className="footer__links-grid">
          <div className="footer__column">
            <h2>Quick Links</h2>
            <ul>
              <li><NavLink to="/sneakers">Sneakers</NavLink></li>
              <li><NavLink to="/sketch">Sketch</NavLink></li>
              <li><NavLink to="/gulueffect">Gulu Effect</NavLink></li>
              <li><NavLink to="/login">Login/Signup</NavLink></li>
            </ul>
          </div>
          <div className="footer__column">
            <h2>Important Info</h2>
            <ul>
              <li><NavLink to="/termsofservices">Terms of Service</NavLink></li>
              <li><NavLink to="/privacy-policy">Privacy Policy</NavLink></li>
              <li><NavLink to="/contact-us">Contact Us</NavLink></li>
            </ul>
          </div>
          <div className="footer__column">
            <h2>Social Media</h2>
            <ul>
              <li><a href="https://www.instagram.com/sneakerproduction.co/" target="_blank" rel="noopener noreferrer">Instagram</a></li>
              <li><a href="https://www.tiktok.com/@sneakerproduction_" target="_blank" rel="noopener noreferrer">Tik Tok</a></li>
              <li><a href="https://wa.me/27680592688" target="_blank" rel="noopener noreferrer">Whatsapp</a></li>
            </ul>
          </div>
        </div>

        <div className="footer__logo-section">
          <NavLink to="/"><img src={footer_logo} alt="Footer Logo" /></NavLink>
        </div>
      </div>

      <div className="footer__bottom-bar">
        <p>Copyright © 2024 Sneaker Production Co. All Rights Reserved.</p>
        <p>Designed by <a href="https://www.instagram.com/somber_8/" target="_blank" rel="noopener noreferrer">Lati</a></p>
      </div>
    </footer>
  );
}

export default Footer;